import { BorderColor } from "@mui/icons-material";

const checkboxStyle = {
  "& .MuiSvgIcon-root": { fontSize: 24 },
  color: "#0A4197",
  "&.Mui-checked": {
    color: "#0A4197",
  },
  padding: "0px",
};

const checkboxStyleGreen = {
  "& .MuiSvgIcon-root": { fontSize: 24 },
  color: "#00B960",
  "&.Mui-checked": {
    color: "#00B960",
  },
  padding: "9px",
};

const radioStyle = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  color: "#E0E0E0",
  "&.Mui-checked": {
    color: "#0A4197",
  },
  padding: "0px",
};

const radioStyleGreen = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  color: "#E0E0E0",
  "&.Mui-checked": {
    color: "#00B960",
  },
  padding: "0px",
};

const radioStyleGreenFormControl = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  color: "#E0E0E0",
  "&.Mui-checked": {
    color: "#00B960",
  },
  padding: "9px",
};

const radioStyleGreenQuiz = {
  "& .MuiSvgIcon-root": { fontSize: 28 },
  color: "rgba(0, 0, 0, 0.6)",
  "&.Mui-checked": {
    color: "#00B960",
  },
  padding: "9px",
};

const calendarStyleGreen = {
  ".MuiButtonBase-root": {
    backgroundColor: "#00B960"
  },
  ".MuiButtonBase-root": {
    backgroundColor: "#00B960"
  }
};



const globalStyle = { checkboxStyle, checkboxStyleGreen, radioStyle, radioStyleGreen, radioStyleGreenFormControl, calendarStyleGreen , radioStyleGreenQuiz };

export default globalStyle;
